import React, { useState } from "react";
import { useTransition, animated } from "react-spring";
import useInterval from "@use-it/interval";

let count = 0;

const Carousel = () => {
  const [slides, setSlides] = useState([0]);
  const transitions = useTransition(slides, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
  });

  useInterval(() => {
    count += 1;
    setSlides([count % 3]);
  }, 5000);

  return (
    <div className="carousel">
      {transitions((style, item) => (
        <animated.div style={style}>
          <div className={`slide slide-${item + 1}`}></div>
        </animated.div>
      ))}
    </div>
  );
};

export default Carousel;
